export enum EditMode {
  View,
  Edit,
  Add
}